import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { TopBar } from "@/components/TopBar";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { t, login } = useApp();
  const nav = useNavigate();
  const [isRegister, setIsRegister] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const path = isRegister ? "/auth/register" : "/auth/login";
      const payload = isRegister
        ? { name: form.name, email: form.email, password: form.password, phone: form.phone }
        : { email: form.email, password: form.password };
      const { data } = await api.post(path, payload);
      login(data.token, data.user);
      toast.success(t("t_login_ok"));
      nav(data.user.role === "admin" ? "/admin" : "/customer");
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail) || t("t_error"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen">
      <TopBar showBack backTo="/" />
      <div className="mx-auto max-w-md px-4 py-14 sm:px-6">
        <div className="animate-fade-up rounded-[20px] border border-border bg-card p-8 shadow-[0_8px_30px_rgba(62,97,72,0.06)]">
          <h1 className="font-serif-h text-3xl text-foreground" data-testid="auth-title">
            {isRegister ? t("register") : t("login")}
          </h1>
          <form onSubmit={submit} className="mt-6 space-y-4">
            {isRegister && (
              <div>
                <Label className="mb-1.5 block text-sm">{t("name")}</Label>
                <Input data-testid="auth-name" value={form.name} onChange={set("name")} required className="rounded-[12px] focus-visible:ring-primary" />
              </div>
            )}
            <div>
              <Label className="mb-1.5 block text-sm">{t("email")}</Label>
              <Input data-testid="auth-email" type="email" value={form.email} onChange={set("email")} required className="rounded-[12px] focus-visible:ring-primary" />
            </div>
            {isRegister && (
              <div>
                <Label className="mb-1.5 block text-sm">{t("phone")}</Label>
                <Input data-testid="auth-phone" value={form.phone} onChange={set("phone")} className="rounded-[12px] focus-visible:ring-primary" />
              </div>
            )}
            <div>
              <Label className="mb-1.5 block text-sm">{t("password")}</Label>
              <Input data-testid="auth-password" type="password" value={form.password} onChange={set("password")} required className="rounded-[12px] focus-visible:ring-primary" />
            </div>
            <Button type="submit" disabled={busy} data-testid="auth-submit" className="w-full rounded-full bg-primary py-6 text-base font-medium text-primary-foreground transition-transform hover:-translate-y-0.5 hover:bg-[#2C4633]">
              {isRegister ? t("register") : t("login")}
            </Button>
          </form>
          <button
            data-testid="auth-toggle"
            onClick={() => setIsRegister(!isRegister)}
            className="mt-5 w-full text-center text-sm text-primary hover:underline"
          >
            {isRegister ? t("to_login") : t("to_register")}
          </button>
        </div>
      </div>
    </div>
  );
}
